import { ModalsProvider } from '@saas-ui/modals'
import { Outlet, createFileRoute, redirect } from '@tanstack/react-router'

import { AppLoader } from '@trevize/ui/app-loader'

import { authClient } from '#features/auth/auth-service.ts'
import { AppZeroProvider } from '#features/zero/app-zero-provider'

export const Route = createFileRoute('/_app')({
  beforeLoad: async ({ location }) => {
    const session = await authClient.getSession()

    if (!session.data?.session || !session.data.user) {
      // Forward the invite code from invite links so signup can prefill it
      const inviteCode = new URLSearchParams(location.searchStr).get(
        'invite_code',
      )

      throw redirect({
        to: '/login',
        search: {
          redirectTo: location.href,
          invite_code: inviteCode ?? undefined,
        },
      })
    }

    document.body.classList.add('loaded')

    return {
      session: session.data.session,
      user: session.data.user,
    }
  },
  staleTime: 1000 * 60 * 5,
  gcTime: 1000 * 60 * 10,
  pendingComponent: AppLoader,
  component: () => {
    return (
      <AppZeroProvider>
        <ModalsProvider>
          <Outlet />
        </ModalsProvider>
      </AppZeroProvider>
    )
  },
})
